import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "common/locales";

interface ConfirmDeleteDialogProps {
  dialogOpen: boolean;
  deletedObjectDescription: string;
  closeDialog: () => void;
  onConfirmDelete: () => void;
  /** Overrides the default "Delete file" title (e.g. for non-file objects). */
  title?: string;
  /** Overrides the default file-specific confirmation message. */
  text?: string;
}

export default function ConfirmDeleteDialog(props: ConfirmDeleteDialogProps) {
  const {
    onConfirmDelete,
    dialogOpen,
    closeDialog,
    deletedObjectDescription,
    title,
    text,
  } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={dialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"xs"}
    >
      <DialogTitle id="alert-dialog-title">
        {title ?? t("confirmdeletedialog.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {text ??
            t("confirmdeletedialog.text", {
              fileName: deletedObjectDescription,
            })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onConfirmDelete();
            closeDialog();
          }}
          color="secondary"
        >
          {t("confirmdeletedialog.confirm.label")}
        </Button>
        <Button
          onClick={() => {
            closeDialog();
          }}
          color="primary"
          autoFocus
        >
          {t("confirmdeletedialog.cancel.label")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
